import { TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function NameField() {
  const { formatMessage } = useIntl();

  return (
    <TextFieldElement
      name="name"
      label={formatMessage({
        id: 'admin.users.form.name.label',
        defaultMessage: 'Nombre',
      })}
      fullWidth
      required
    />
  );
}
